module.exports = __webpack_public_path__ + "static/img/bind2.d0806c10.png";